import { type ReactNode } from 'react';
import { useStateQuery } from '../../api/state';
import { Header } from './Header';
import { Footer } from './Footer';
import { StaleConfigBanner } from '../status/StaleConfigBanner';
import { ConnectionBanner } from '../status/ConnectionBanner';
import { DeviceOfflineBanner } from '../status/DeviceOfflineBanner';

export function AppShell({ children }: { children: ReactNode }) {
  const { data } = useStateQuery();
  return (
    <div className="layout">
      <Header systemMode={data?.systemMode} faultCount={data?.active_faults.length ?? 0} />
      <ConnectionBanner />
      <DeviceOfflineBanner lastReportedAt={data?.lastReportedAt} />
      {data?.isStaleConfig && <StaleConfigBanner />}
      {children}
      <Footer deviceId={data?.deviceId} firmwareVersion={data?.firmwareVersion} lastReportedAt={data?.lastReportedAt} />
    </div>
  );
}
